import { BRAND } from '../../../../bin/constants';

// ---

export type BrandName = keyof typeof BRAND;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace NodeJS {
    interface ProcessEnv {
      BRAND_NAME: BrandName;
      NODE_ENV: 'production' | 'development';
    }
  }
}

function getBrandName(): BrandName {
  if (process.env.NODE_ENV === 'production') { // Условие для tree shaking'a
    return process.env.BRAND_NAME;
  }

  const name = typeof window === 'undefined'
    ? process.env.BRAND_NAME
    : window.__env.BRAND_NAME;

  if (!Object.keys(BRAND).includes(name)) {
    throw new Error('Бренд не установлен.');
  }

  return name;
}

export { getBrandName };
